module.exports = __webpack_public_path__ + "static/media/usr-logo.ea4171fb.svg";